import React, { useState, useEffect } from 'react';

import { Dropdown, FormInput_text, FormInput_textarea, formInput_funcUtility, FormGroupRadio, Toaster } from "components";

import { func_validation, func_currency, isStringEqual_caseInsensitive, isStringTrimNotEmpty, isStringNotEmpty, isStringTrimEmpty, isNullUndefined, getObjectPropertyValue_stringTrimNotEmpty, getObjectPropertyValue_validNumber, convertArrayToDropdownArrayFormat, getRegexMatchCurrencyDoublePrecisionCaseInsensitive, isNumberWithinRange, isNumberValid, getParsedFormattedFloat, isNumberOrStringValid, getObjectPropertyValue } from "functions";
import { FormCheckbox } from 'components/form/formCheckbox/FormCheckbox';
import { chargeMethodList } from 'constants/lists';

export function useChargeInputs(props) {
    // Props
    const {
        isEditing,
        billingSetup,    
        isFormSubmissionAttempted,
        isDefaultProduct, referenceValue,
        chargeMethod, setChargeMethod, chargeMethod_init,
        isDraft, // Get draft status to control input disabling

        setReferenceValue = () => {},
        setReferenceValuePlaceholder = () => {},
        setIsDefaultProduct = () => {},
        setIsDefaultProductDisabled = () => {}
    } = props;

    // Validate initial state values
    let posCountToCharge_init = getObjectPropertyValue_validNumber(billingSetup, "POSCountToCharge", 0);
    let systemChargeMethodComment_init = getObjectPropertyValue_stringTrimNotEmpty(billingSetup, "SystemChargeMethodComment", "");
    let subscriptionMethod_init = getObjectPropertyValue_stringTrimNotEmpty(billingSetup, "SubscriptionMethod", "Monthly");
    let frequency_init = getObjectPropertyValue_validNumber(billingSetup, "BillFrequence", 1);
    let unitPrice_init = getObjectPropertyValue_validNumber(billingSetup, "UnitPrice", "0.00") + "";
    unitPrice_init = func_currency.validateStringDoublePrecisionCurrency(unitPrice_init, '0.00');
    let quantity_init = getObjectPropertyValue_validNumber(billingSetup, "Quantity", 0);
    let unitDiscountAmount_init = getObjectPropertyValue_validNumber(billingSetup, "UnitDiscountAmount", "0.00") + "";
    unitDiscountAmount_init = func_currency.validateStringDoublePrecisionCurrency(unitDiscountAmount_init, '0.00');
    let currencyCode_init = getObjectPropertyValue_stringTrimNotEmpty(billingSetup, "CurrencyCode", "MYR");
    let currencyRate_init = getObjectPropertyValue_validNumber(billingSetup, "CurrencyRate", 1) + "";
    currencyRate_init = func_currency.validateStringDoublePrecisionCurrency(currencyRate_init, '1.00');
    let transactionCountToCharge_init = getObjectPropertyValue_validNumber(billingSetup, "TransactionCountToCharge", "");
    let subsidiary_init = getObjectPropertyValue(billingSetup, "Subsidiary");

    // States
    const [posCountToCharge, setPosCountToCharge] = useState(posCountToCharge_init);
    const [systemChargeMethodComment, setSystemChargeMethodComment] = useState(systemChargeMethodComment_init);
    const [subscriptionMethod, setSubscriptionMethod] = useState(subscriptionMethod_init);
    const [frequency, setFrequency] = useState(frequency_init);
    const [unitPrice, setUnitPrice] = useState(unitPrice_init);
    const [quantity, setQuantity] = useState(quantity_init);
    const [unitDiscountAmount, setUnitDiscountAmount] = useState(unitDiscountAmount_init);
    const [currencyCode, setCurrencyCode] = useState(currencyCode_init);
    const [currencyRate, setCurrencyRate] = useState(currencyRate_init);
    const [transactionCountToCharge, setTransactionCountToCharge] = useState(transactionCountToCharge_init);
    const [subsidiary, setSubsidiary] = useState(subsidiary_init);
    const [isAnyInputChanged, setIsAnyInputChanged] = useState(false);
    const [isMounted, setIsMounted] = useState();

    useEffect(() => {
        if (!isMounted) setIsMounted(true);
    },[])

    // Check for changes in input from initial
    useEffect(() => {
        let isNotChangedFromOriginal = (
            chargeMethod === chargeMethod_init &&
            posCountToCharge === posCountToCharge_init &&
            systemChargeMethodComment === systemChargeMethodComment_init &&
            subscriptionMethod === subscriptionMethod_init &&
            frequency === frequency_init &&
            unitPrice === unitPrice_init &&
            quantity === quantity_init &&
            unitDiscountAmount === unitDiscountAmount_init &&
            currencyCode === currencyCode_init &&
            currencyRate === currencyRate_init &&
            transactionCountToCharge === transactionCountToCharge_init
        );

        let isChangedFromEmpty = (
            chargeMethod ||
            isNumberOrStringValid(posCountToCharge) ||
            systemChargeMethodComment ||
            subscriptionMethod ||
            isNumberOrStringValid(frequency) ||
            isNumberOrStringValid(unitPrice) ||
            isNumberOrStringValid(quantity) ||
            isNumberOrStringValid(unitDiscountAmount) ||
            currencyCode ||
            currencyRate ||
            isNumberOrStringValid(transactionCountToCharge)
        );

        setIsAnyInputChanged(isEditing? !isNotChangedFromOriginal: isChangedFromEmpty);   
    }, [
        chargeMethod, posCountToCharge, systemChargeMethodComment, subscriptionMethod,
        frequency, unitPrice, quantity, unitDiscountAmount,
        currencyCode, currencyRate, transactionCountToCharge
    ]);

    function posCountToCharge_onClick() {
        if (!isStringEqual_caseInsensitive(chargeMethod, "OutletPos"))
            Toaster({
                type: "info",
                msg: "Please set Charge Method input as Outlet POS."
            });
    }

    function posCountToCharge_updateStates() {
        if (!isStringEqual_caseInsensitive(chargeMethod, "OutletPos") &&
            (posCountToCharge != 0)) {

            setPosCountToCharge(0);
        }
    }
    function systemChargeMethodComment_updateStates() {
        if (isStringTrimNotEmpty(systemChargeMethodComment)) {

            setSystemChargeMethodComment("");
        }
    }
    function systemChargeMethod_updateReferenceValue() {
        if (isStringEqual_caseInsensitive(chargeMethod, "System")) {

            setReferenceValue("System");
            setReferenceValuePlaceholder("1 value(s)");
            setIsDefaultProduct(false);
            setIsDefaultProductDisabled(true);
        }
        else if (referenceValue === "System") {
            setReferenceValue("");
            setReferenceValuePlaceholder("");
            setIsDefaultProductDisabled(false);
        }
        else {
            setIsDefaultProductDisabled(false);
        }
    }
    useEffect(() => {
        if (isMounted) {
            systemChargeMethod_updateReferenceValue();
            systemChargeMethodComment_updateStates();
            posCountToCharge_updateStates();
        }
    }, [chargeMethod]);
    useEffect(() => {
        if (isMounted) {
            if (!isDefaultProduct &&
                isStringEqual_caseInsensitive(chargeMethod, "System")) {
    
                setReferenceValue("System");
                setReferenceValuePlaceholder("1 value(s)");
            }
            else {
                setReferenceValue("");
                setReferenceValuePlaceholder("");
            }   
        }
    }, [isDefaultProduct]);

    // Display
    let display = (
        <div className="recursiveBillingSetupAccountUpdate-charge d-flex flex-wrap">
            {/* Charge Method */}
            <Dropdown
                className={"recursiveBillingSetupAccountUpdate-chargeMethod"}
                label={"Charge Method"}
                isInputRequired

                selectedValueClassName={"recursiveBillingSetupAccountUpdate-chargeMethod-input"}

                options={chargeMethodList}
                selectedValue_default={chargeMethod}
                onChange={setChargeMethod}

                errorMsg={(isStringTrimEmpty(chargeMethod) || isNullUndefined(chargeMethod))? "Required":
                                (chargeMethod === "System" && isDefaultProduct)? "System cannot be set as default product":
                                    (chargeMethod === "OutletPos" && !isNumberWithinRange(posCountToCharge, { min: 1 }))? "Outlet Pos must have a value greater than 0 for 'POS count to charge'":
                                        (chargeMethod === "OutletTransaction" && !isNumberValid(transactionCountToCharge)? "Outlet Transaction must have a value for 'transaction count to charge'":
                                            "")}
                customErrorValidation={isFormSubmissionAttempted && 
                    (isStringTrimEmpty(chargeMethod) || isNullUndefined(chargeMethod) ||
                    (chargeMethod === "System" && isDefaultProduct) ||
                    (chargeMethod === "OutletPos" && !isNumberValid(posCountToCharge)) ||
                    (chargeMethod === "OutletTransaction" && !isNumberValid(transactionCountToCharge)))}
                isFormSubmissionAttempted={isFormSubmissionAttempted}

                isDisabled={isEditing && !isDraft}

                isSearchable isSortingOptional
            />

            {/* Subscription Method */}
            <Dropdown
                className={"recursiveBillingSetupAccountUpdate-subscriptionMethod"}
                label={"Subscription Method"}
                isInputRequired

                selectedValueClassName={"recursiveBillingSetupAccountUpdate-subscriptionMethod-input"}

                options={[
                    {
                        label: "Monthly",
                        value: "Monthly"
                    },
                    {
                        label: "Daily",
                        value: "Daily"
                    }
                ]}
                selectedValue_default={subscriptionMethod}
                onChange={setSubscriptionMethod}

                errorMsg={"Required"}
                isFormSubmissionAttempted={isFormSubmissionAttempted}

                isDisabled={isEditing && !isDraft}

                isSearchable
                isInputValueTrim_onChange
            />

            {/* Frequency */}
            <Dropdown
                className={"recursiveBillingSetupAccountUpdate-frequency"}
                label={"Bill Frequency"}
                isInputRequired

                selectedValueClassName={"recursiveBillingSetupAccountUpdate-frequency-input"}

                options={convertArrayToDropdownArrayFormat([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])}
                selectedValue_default={frequency}
                onChange={setFrequency}

                errorMsg={"Required"}
                isFormSubmissionAttempted={isFormSubmissionAttempted}

                minInputDigit={1}
                minInputDigit_invalidMsg={"Bill Frequency must be at least 1"}
                isInputDigitOnly
                
                isDisabled={isEditing && !isDraft}

                isSearchable
                isInputValueTrim_onChange 
            />

            {/* Unit Price */}
            <FormInput_text  
                inputLabel={"Unit Price (RM)"}

                className={"recursiveBillingSetupAccountUpdate-unitPrice"}
                inputValue_default={unitPrice} 

                handleInputBlurExtend={(value) => { 
                    if (isStringTrimNotEmpty(value)) setUnitPrice(value);
                    else setUnitPrice("");
                }}

                inputMaxLength={64} 

                customErrorMsgDefault={"Required"}
                isFormSubmissionAttempted={isFormSubmissionAttempted} 

                handleInputFocusExtend={(e)=>{ formInput_funcUtility.handleInputFocus_onEnter_selectInput(e); }}
                isValuePropagationGuarded_onChange={(value)=>{ return (value.match(getRegexMatchCurrencyDoublePrecisionCaseInsensitive()) || value == '') }}
                customValidator_onBlur={(value)=>{ return func_currency.validateStringDoublePrecisionCurrency(value, '0.00'); }}

                isInputValueTrim_onChange 
                isInputBlurHandlingRequired isInputValueTrim_onBlur
                isMarginBtmOptional

                isInputDisabled={isEditing && !isDraft}
            />

            {/* Quantity */}
            <FormInput_text  
                inputLabel={"Quantity"}

                className={"recursiveBillingSetupAccountUpdate-quantity"}
                inputValue_default={quantity} 

                isInputBlurHandlingRequired
                handleInputBlurExtend={(value) => { setQuantity(value); }}

                inputMaxLength={64}

                customErrorMsgDefault={"Required"}
                isFormSubmissionAttempted={isFormSubmissionAttempted}

                isInputValueTrim_onChange
                isMarginBtmOptional isInputDigitOnly isConvertedToNumber

                isInputDisabled={isEditing && !isDraft}
            />

            {/* Unit Discount Amount */}
            <FormInput_text  
                inputLabel={"Unit Discount Amount (RM)"}
                isInputOptional

                className={"recursiveBillingSetupAccountUpdate-unitDiscountAmount"}
                inputValue_default={unitDiscountAmount}

                handleInputBlurExtend={(value) => { setUnitDiscountAmount(value); }}

                inputMaxLength={64} 

                handleInputFocusExtend={(e)=>{ formInput_funcUtility.handleInputFocus_onEnter_selectInput(e); }}
                isValuePropagationGuarded_onChange={(value)=>{ return (value.match(getRegexMatchCurrencyDoublePrecisionCaseInsensitive()) || value == '') }}
                customValidator_onBlur={(value)=>{ return func_currency.validateStringDoublePrecisionCurrency(value, '0.00'); }}

                isInputValueTrim_onChange
                isInputBlurHandlingRequired isInputValueTrim_onBlur
                isMarginBtmOptional isErrorMsgOptional

                // isInputDisabled={true} // Always disabled - use BillingSetupDiscounts instead
                isInputDisabled={isEditing && !isDraft}
            />

            {/* Currency Code */}
            <FormInput_text  
                inputLabel={"Currency Code"}

                className={"recursiveBillingSetupAccountUpdate-currencyCode"}
                inputValue_default={currencyCode} 

                isInputBlurHandlingRequired
                handleInputBlurExtend={(value) => { setCurrencyCode(value); }}

                inputMaxLength={3} 

                customErrorMsgDefault={"Required"}
                isFormSubmissionAttempted={isFormSubmissionAttempted} 

                isInputValueTrim_onChange
                isMarginBtmOptional

                isInputDisabled={isEditing && !isDraft}
            />

            {/* Currency Rate */}
            <FormInput_text  
                inputLabel={"Currency Rate"}
                isInputOptional

                className={"recursiveBillingSetupAccountUpdate-currencyRate"}
                inputValue_default={currencyRate} 

                isInputBlurHandlingRequired
                handleInputBlurExtend={(value) => { 
                    if (isStringTrimNotEmpty(value)) setCurrencyRate(value);
                    else setCurrencyRate("");
                }}

                inputMaxLength={64} 

                handleInputFocusExtend={(e)=>{ formInput_funcUtility.handleInputFocus_onEnter_selectInput(e); }}
                isValuePropagationGuarded_onChange={(value)=>{ return (value.match(getRegexMatchCurrencyDoublePrecisionCaseInsensitive()) || value == '') }}
                customValidator_onBlur={(value)=>{ return func_currency.validateStringDoublePrecisionCurrency(value, '1.00'); }}

                isInputValueTrim_onChange 
                isInputValueTrim_onBlur
                isMarginBtmOptional isErrorMsgOptional

                isInputDisabled={isEditing && !isDraft}
            />

            {/* Transaction Count to Charge */}
            <FormInput_text
                inputLabel={"Transaction Count to Charge"}
                isInputOptional={!isStringEqual_caseInsensitive(chargeMethod, "OutletTransaction")}

                className={"recursiveBillingSetupAccountUpdate-transactionCountToCharge"}
                inputValue={transactionCountToCharge} 

                isInputBlurHandlingRequired
                handleInputBlurExtend={(value) => { 
                    setTransactionCountToCharge(value); 
                }}

                inputMaxLength={64} 

                customErrorMsgDefault={"Required"}
                customErrorValidation={isStringEqual_caseInsensitive(chargeMethod, "OutletTransaction") &&
                    (!isNumberValid(transactionCountToCharge)) &&
                    isFormSubmissionAttempted}

                isInputValueTrim_onChange
                isMarginBtmOptional isInputDigitOnly isConvertedToNumber

                isInputDisabled={isEditing && !isDraft}
            />

            {/* POS Count To Charge */}
            <FormInput_text  
                inputLabel={"POS Count to Charge"}
                isInputOptional={!isStringEqual_caseInsensitive(chargeMethod, "OutletPos")}

                className={"recursiveBillingSetupAccountUpdate-posCountToCharge"}
                inputValue={posCountToCharge}

                handleInputClickExtend={posCountToCharge_onClick}
                isInputClickHandlingRequired

                handleInputBlurExtend={(value) => { setPosCountToCharge(value); }}
                isInputBlurHandlingRequired

                inputMaxLength={64}

                customErrorMsgDefault={"Input required to be greater than 0"}
                customErrorValidation={isStringEqual_caseInsensitive(chargeMethod, "OutletPos") &&
                    (!isNumberWithinRange(posCountToCharge, { min: 1 })) &&
                    isFormSubmissionAttempted}

                isInputValueTrim_onChange
                isMarginBtmOptional isInputDigitOnly isConvertedToNumber
                isInputDisabled={!isStringEqual_caseInsensitive(chargeMethod, "OutletPos") || (isEditing && !isDraft)}
                // inputCustomOptions={{ readOnly: (!isStringEqual_caseInsensitive(chargeMethod, "OutletPos")) }}
            />

            {/* Subsidiary */}
            <FormInput_text
                inputLabel={"Subsidiary"}
                isInputOptional
                className={"recursiveBillingSetupAccountUpdate-subsidiary"}
                inputValue={subsidiary} 
                inputMaxLength={64}
                isMarginBtmOptional
                isInputDisabled={true}
            />

            {/* System Charge Method Comment */}
            <FormInput_textarea
                inputLabel={"System Charge Method Comment"}
                isInputOptional

                className={"recursiveBillingSetupAccountUpdate-systemChargeMethodComment"}
                customInputClassName={"recursiveBillingSetupAccountUpdate-systemChargeMethodComment-input"}
                inputValue={systemChargeMethodComment}

                handleInputBlurExtend={(value) => { setSystemChargeMethodComment(value); }}
                isInputBlurHandlingRequired

                isInputValueTrim_onChange isMarginBtmOptional isErrorMsgOptional
                isInputDisabled={isEditing && !isDraft}
                // inputCustomOptions={{ readOnly: (!isStringEqual_caseInsensitive(chargeMethod, "System")) }}
            />
        </div>
    );

    function isChargeMethodValid() {
        return (isStringTrimNotEmpty(chargeMethod) &&
        ((isStringEqual_caseInsensitive(chargeMethod, "OutletTransaction") && isNumberValid(transactionCountToCharge)) || 
            (!isStringEqual_caseInsensitive(chargeMethod, "OutletTransaction"))) &&
        ((isStringEqual_caseInsensitive(chargeMethod, "OutletPos") && isNumberValid(posCountToCharge)) || 
            (!isStringEqual_caseInsensitive(chargeMethod, "OutletPos"))) &&
        ((isStringEqual_caseInsensitive(chargeMethod, "System") && !isDefaultProduct && (referenceValue === "System")) ||
            (!isStringEqual_caseInsensitive(chargeMethod, "System"))));
    }
    let isEveryInputValid = (
        isChargeMethodValid() &&
        isStringTrimNotEmpty(subscriptionMethod) &&
        isNumberValid(frequency) && (frequency > 0) &&
        isStringTrimNotEmpty(unitPrice) &&
        isNumberValid(quantity) &&
        // isStringTrimNotEmpty(unitDiscountAmount) &&
        // isStringTrimNotEmpty(currencyRate) &&
        isStringTrimNotEmpty(currencyCode)
    );

    let chargeDetails = {
        ChargeMethod: chargeMethod,
        POSCountToCharge: posCountToCharge,
        SystemChargeMethodComment: systemChargeMethodComment,
        SubscriptionMethod: subscriptionMethod,
        BillFrequence: frequency,
        UnitPrice: getParsedFormattedFloat(unitPrice),
        Quantity: quantity,
        UnitDiscountAmount: isStringTrimNotEmpty(unitDiscountAmount)? getParsedFormattedFloat(unitDiscountAmount):0,
        CurrencyCode: currencyCode,
        CurrencyRate: isStringTrimNotEmpty(currencyRate)? getParsedFormattedFloat(currencyRate):1,
        TransactionCountToCharge: transactionCountToCharge 
    }

    return {
        chargeDetails,

        isEveryInputValid,
        isAnyInputChanged,
        display
    }
}